/* eslint-disable */
import AuthHeader from "components/common/AuthHeader";
import React, { useContext, useEffect } from "react";
//import context
import { GlobalProvider } from "context/GlobalContext";
import PayInvoice from "components/PaymentComponents/PayInvoice/PayInvoice";

const Quickpay = () => {
  return (
    <>
      <header className="aftre_login_header">
        <AuthHeader />
      </header>

      {/* ------ body section --------- */}
      <PayInvoice />
    </>
  );
};

export default Quickpay;